import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useUserSettings } from '../../io/context/UserSettings'

type UserSettingsDialogProps = {
  open: boolean
  onClose: () => void
}

const UserSettingsDialog = ({ open, onClose }: UserSettingsDialogProps) => {
  const { openAiApiKey, setOpenAiApiKey } = useUserSettings()
  const [apiKeyValue, setApiKeyValue] = useState(openAiApiKey ?? '')

  useEffect(() => {
    if (open) {
      setApiKeyValue(openAiApiKey ?? '')
    }
  }, [open, openAiApiKey])

  const handleSave = () => {
    const trimmed = apiKeyValue.trim()
    setOpenAiApiKey(trimmed || null)
    onClose()
  }

  const handleCancel = () => {
    setApiKeyValue(openAiApiKey ?? '')
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>User Settings</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="OpenAI API Key"
          type="password"
          fullWidth
          variant="outlined"
          value={apiKeyValue}
          onChange={(e) => setApiKeyValue(e.target.value)}
          placeholder="sk-..."
          helperText="Your personal OpenAI API key for the AI assistant"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UserSettingsDialog
